<template>
  <!--  노션 링크 : https://www.notion.so/ReservguidancePage-775f2a13c2d54be98bf1e9cf8045cb72 -->
  <div>
    <div>
      <breadcrumb :breadcrumb_link="reserveguidance_breadcrumb" />
    </div>

    <div class="header">
      <!--      <h1 class="overlay">GUIDE PROGRAM</h1>-->
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="contentDesc">
      <div class="title1">
        <h2>
          <strong>{{ $t('resvgu_title') }}</strong>
        </h2>
      </div>
    </div>

    <div class="container" v-show="isLang === 0">
      <div :class="{anotherword: isLang === 0}">
        <div>
          <ul class="rev_info list-unstyled mb-3">
            <!--            <li class="mb-1 text_align1">
              핀크스 골프클럽은 고객과의 1:1 대화형 서비스를 원칙으로 하기 때문에 온라인 예약 대신 전화와 이메일 접수를
              운영하고 있습니다.
            </li>-->
            <li class="text_align1">
              원활한 골프 예약문화의 정착과 회원들간의 균등한 예약 기회 배분을 위하여 다음과 같이 위약 규정을 안내하오니
              많은 협조 부탁 드립니다.
            </li>
          </ul>
        </div>

        <div class="container">
          <!--        <div class="row justify-content-md-center" style="border: 0.5px solid lightgray">
          <div class="col col-lg-3">
            <b-icon icon="phone" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon> TEL : 064-792-8000
          </div>
          <div class="col col-md-auto"></div>
          <div class="col col-lg-3"></div>
        </div>-->
          <div class="row justify-content-md-center web">
            <table class="table table-borderless border table-striped rounded">
              <tbody>
                <tr class="text-center">
                  <td>
                    <b-icon icon="phone" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon>
                  </td>
                  <td class="align-middle">TEL : 064-792-8000</td>
                  <td class="align-middle">EMAIL : <ObfuscatedEmail email-key="bookingKr" /></td>
                  <td>
                    <b-icon icon="calendar2-check" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon>
                  </td>
                  <td class="align-middle">연중무휴 09:00 ~ 17:30</td>
                  <td class="align-middle">점심시간 12:00 ~ 13:00</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="row justify-content-md-center mobile">
            <table class="table table-borderless border table-striped rounded">
              <tbody>
                <tr class="text-center">
                  <td>
                    <b-icon icon="phone" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon>
                  </td>
                  <td>
                    <div class="text-left">TEL : 064-792-8000</div>
                    <div class="text-left">EMAIL : <ObfuscatedEmail email-key="bookingKr" /></div>
                  </td>
                </tr>
                <tr class="text-center">
                  <td>
                    <b-icon icon="calendar2-check" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon>
                  </td>
                  <td>
                    <div class="text-left">연중무휴 09:00 ~ 17:30</div>
                    <div class="text-left">점심시간 12:00 ~ 13:00</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="container" style="margin-top: 30px; margin-bottom: 15px">
          <b-icon icon="exclamation-circle-fill" font-scale="1"></b-icon>
          <strong> 예약 방법 안내</strong>
        </div>

        <table class="table table-borderless web">
          <tbody align="center">
            <tr style="border-top: 2px solid">
              <td class="rb_border" style="background-color: #f5f5f5" width="150px">신청 접수</td>
              <td style="border-bottom: 1px solid #acacac">8주 전 월요일 9시부터 수요일 17시까지 접수 가능합니다.</td>
            </tr>
            <tr>
              <td class="rb_border" style="background-color: #f5f5f5">예약 확인</td>
              <td style="border-bottom: 1px solid #acacac">
                7주 전 월요일 13시 이후부터 순차적으로 배정 안내 드립니다.
              </td>
            </tr>
            <tr>
              <td class="rb_border" style="background-color: #f5f5f5">예약 취소</td>
              <td style="border-bottom: 1px solid #acacac">7일전 17시까지 무료 취소 가능합니다.</td>
            </tr>
            <tr>
              <td class="rb_border align-middle" style="background-color: #f5f5f5">대기 접수</td>
              <td style="border-bottom: 1px solid #acacac">
                예약이 종료 된 이후부터 대기 신청 가능합니다.<br />대기는 취소 발생 후 대기 순위에서 최근 이용하지 않은
                회원을 우선 배정합니다.
              </td>
            </tr>
          </tbody>
        </table>

        <table class="info-ex-table table table-borderless mobile">
          <tbody align="center">
            <tr style="border-top: 2px solid">
              <td style="background-color: #f5f5f5; border-bottom: 1px solid #acacac">신청 접수</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid #acacac">8주 전 월요일 9시부터 수요일 17시까지 접수 가능합니다.</td>
            </tr>
            <tr>
              <td style="background-color: #f5f5f5; border-bottom: 1px solid #acacac">예약 확인</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid #acacac">
                7주 전 월요일 13시 이후부터 순차적으로 배정 안내 드립니다.
              </td>
            </tr>
            <tr>
              <td style="background-color: #f5f5f5; border-bottom: 1px solid #acacac">예약 취소</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid #acacac">7일전 17시까지 무료 취소 가능합니다.</td>
            </tr>
            <tr>
              <td style="background-color: #f5f5f5; border-bottom: 1px solid #acacac">대기 접수</td>
            </tr>
            <tr>
              <td style="border-bottom: 1px solid #acacac">
                예약이 종료 된 이후부터 대기 신청 가능합니다.<br />대기는 취소 발생 후 대기 순위에서 최근 이용하지 않은
                회원을 우선 배정합니다.
              </td>
            </tr>
          </tbody>
        </table>

        <div class="container" style="margin-top: 30px; margin-bottom: 15px">
          <b-icon icon="exclamation-circle-fill" font-scale="1"></b-icon>
          <strong> 예약 배정 기준 안내</strong>
        </div>

        <ul class="rev_info list-unstyled">
          <table class="table table-borderless">
            <tbody>
              <tr style="border-top: 2px solid">
                <td>
                  <li>회원 구좌별 1일 1팀으로 배정됩니다.</li>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #acacac; border-top: 1px solid #acacac">
                <td style="letter-spacing: -0.04rem">
                  <li>가족 회원 / 지정회원보다 정회원 배정을 우선 합니다.</li>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #acacac">
                <td>
                  <li>최근 이용하지 않은 회원을 우선 배정합니다.</li>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #acacac">
                <td>
                  <li class="text_align1">
                    2인 플레이는 정회원 월요일~금요일 1부, 일요일 2부에 한하여 라운드가 가능합니다.
                  </li>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #acacac">
                <td>
                  <li style="letter-spacing: -0.05rem">회원 추천은 4주 전 잔여 타임에 한해 신청 가능합니다.</li>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #acacac">
                <td>
                  <li class="text_align1">
                    예약 후 취소/변경 시에는 대기 회원을 배정하므로, 예약자 명의변경이 불가합니다.
                  </li>
                </td>
              </tr>
              <tr style="border-bottom: 1px solid #acacac">
                <td>
                  <li class="text_align1">
                    예약하신 회원님이 방문하지 않으신 경우 추후 예약 배정 시 불이익을 받을 수 있습니다.
                  </li>
                </td>
              </tr>
              <tr>
                <td style="padding-bottom: 0; font-size: 14px">
                  <div class="text_align2">
                    ※ 코스 관리 및 계절에 따른 2부제 운영 시 9홀 PLAY 후 경기가 일부 지연될 수 있으니 양해 바랍니다.
                  </div>
                </td>
              </tr>
              <tr>
                <td style="padding-top: 0; padding-bottom: 0; font-size: 14px">
                  <div class="text_align2">※ 정기 코스별 휴장 : 매주 월, 화, 수 코스별 휴장</div>
                </td>
              </tr>
              <tr>
                <td style="padding-top: 0; padding-bottom: 0; font-size: 14px">
                  <div class="text_align2">
                    <span class="font-weight-bold">※ 매월 3번째 수요일 정기 휴장일</span> (단, 정기 휴장일은 클럽사정에
                    의해 변동 될 수 있습니다.)
                  </div>
                </td>
              </tr>
              <tr>
                <td style="padding-top: 0; padding-bottom: 0; font-size: 14px">
                  <div class="text_align2">※ 임시휴장 : 천재지변 및 코스관리 등 운영상 필요한 경우 임시휴장</div>
                </td>
              </tr>
            </tbody>
          </table>
        </ul>

        <div class="container" style="margin-top: 30px; margin-bottom: 15px">
          <b-icon icon="exclamation-circle-fill" font-scale="1"></b-icon>
          <strong> 예약 취소/변경 및 위약 규정 안내</strong>
        </div>

        <table class="web table table-borderless">
          <tbody align="center">
            <tr style="border-top: 2px solid; background-color: #f5f5f5">
              <td class="rb_border">구분</td>
              <td class="rb_border">위약 사항</td>
              <td style="border-bottom: 1px solid #acacac">위약 조치</td>
            </tr>
            <tr>
              <td rowspan="4" class="rb_border align-middle" style="background-color: #f5f5f5">
                예약관련<br />위약사항
              </td>
              <td class="rb_border">7일 전 17시까지 취소</td>
              <td style="border-bottom: 1px solid #acacac">무료 취소 가능</td>
            </tr>
            <tr>
              <td class="rb_border">6일 전 ~ 1일 전 취소</td>
              <td style="border-bottom: 1px solid #acacac">1개월 예약 정지</td>
            </tr>
            <tr>
              <td class="rb_border">당일 취소 및 No Show</td>
              <td style="border-bottom: 1px solid #acacac">2개월 예약 정지</td>
            </tr>
            <tr>
              <td class="rb_border">회원 예약 후 비회원 내장 시</td>
              <td style="border-bottom: 1px solid #acacac">2개월 예약 정지</td>
            </tr>
            <tr>
              <td rowspan="2" class="rb_border align-middle" style="background-color: #f5f5f5">기타<br />위약사항</td>
              <td class="rb_border">진행에 비협조하시거나 스타트 시간을 무시하는 경우</td>
              <td rowspan="2" style="border-bottom: 1px solid #acacac">
                누적 2회 발생 시 1개월 예약 정지되며,<br />
                반복적인 위약 및 그 정도가 심할 경우<br />
                회칙에 따라 회원 자격 정지 또는 제명 등이<br />
                이루어 질 수 있습니다.
              </td>
            </tr>
            <tr>
              <td class="rb_border">기타 클럽의 품의를 훼손시키는 경우 (불건전한 언어와 태도 등)</td>
            </tr>
          </tbody>
        </table>

        <table class="mobile table table-borderless">
          <tbody align="center">
            <tr style="border-top: 2px solid; background-color: #f5f5f5; border-bottom: 1px solid #acacac">
              <td colspan="2">예약관련 위반사항</td>
            </tr>
            <tr style="background-color: #f5f5f5">
              <td class="rb_border" width="50%">위약 사항</td>
              <td style="border-bottom: 1px solid #acacac">위약 조치</td>
            </tr>
            <tr>
              <td class="rb_border">7일 전 17시까지 취소</td>
              <td style="border-bottom: 1px solid #acacac">무료 취소 가능</td>
            </tr>
            <tr>
              <td class="rb_border">6일 전 ~ 1일 전 취소</td>
              <td style="border-bottom: 1px solid #acacac">1개월 예약 정지</td>
            </tr>
            <tr>
              <td class="rb_border">당일 취소 및 No Show</td>
              <td style="border-bottom: 1px solid #acacac">2개월 예약 정지</td>
            </tr>
            <tr>
              <td class="rb_border">회원 예약 후 비회원 내장 시</td>
              <td style="border-bottom: 1px solid #acacac">2개월 예약 정지</td>
            </tr>
            <tr style="background-color: #f5f5f5; border-bottom: 1px solid #acacac">
              <td colspan="2">기타 위반사항</td>
            </tr>
            <tr style="background-color: #f5f5f5">
              <td class="rb_border" width="50%">위약 사항</td>
              <td style="border-bottom: 1px solid #acacac">위약 조치</td>
            </tr>
            <tr>
              <td class="rb_border">진행에 비협조하시거나 스타트 시간을 무시하는 경우</td>
              <td rowspan="2" style="border-bottom: 1px solid #acacac">
                누적 2회 발생 시 1개월 예약 정지되며,<br />
                반복적인 위약 및 그 정도가 심할 경우<br />
                회칙에 따라 회원 자격 정지 또는 제명 등이<br />
                이루어 질 수 있습니다.
              </td>
            </tr>
            <tr>
              <td class="rb_border" style="letter-spacing: -0.04rem">
                기타 클럽의 품의를 훼손시키는 경우 (불건전한 언어와 태도 등)
              </td>
            </tr>
            <tr align="left">
              <td colspan="2" style="padding-top: 10px; padding-bottom: 0">
                <div class="text_align2">※ 천재지변 등의 부득이한 사항으로 취소는 제외됩니다.</div>
              </td>
            </tr>
            <tr align="left">
              <td colspan="2" style="padding-top: 0; padding-bottom: 0">※ 예약정지 기간은 취소 당일부터 적용됩니다.</td>
            </tr>
          </tbody>
        </table>

        <div class="web mb-5" style="font-size: 14px">
          ※ 천재지변 등의 부득이한 사항으로 취소는 제외됩니다. <br />
          ※ 예약정지 기간은 취소 당일부터 적용됩니다.
        </div>
      </div>
    </div>

    <div class="container" v-show="isLang === 1 || isLang === 2">
      <div :class="{jpword: isLang === 2}">
        <div :class="{anotherword: isLang === 1}">
          <div style="margin-top: 50px; margin-bottom: 15px">
            <b-icon icon="exclamation-circle-fill" font-scale="1"></b-icon>
            <strong>{{ $t('resvgu_table1_title') }}</strong>
          </div>

          <table class="web table table-borderless">
            <tbody>
              <tr style="border-top: 2px solid">
                <td class="rb_border" style="vertical-align: middle; background-color: #f5f5f5" align="center">
                  {{ $t('resvgu_table1_td2') }}
                </td>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td3')"></td>
              </tr>
              <tr>
                <td class="rb_border" align="center" style="vertical-align: middle; background-color: #f5f5f5">
                  {{ $t('resvgu_table1_td4') }}
                </td>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td5')"></td>
              </tr>
              <tr>
                <td class="rb_border" align="center" style="vertical-align: middle; background-color: #f5f5f5">
                  {{ $t('resvgu_table1_td6') }}
                </td>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td7')"></td>
              </tr>
              <tr>
                <td class="rb_border" align="center" style="vertical-align: middle; background-color: #f5f5f5">
                  {{ $t('resvgu_table1_td8') }}
                </td>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td9')"></td>
              </tr>
              <tr>
                <td class="rb_border" align="center" style="vertical-align: middle; background-color: #f5f5f5">
                  {{ $t('resvgu_table1_td10') }}
                </td>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td11')"></td>
              </tr>
              <tr>
                <td style="padding-bottom: 0" colspan="3">
                  <div class="text_align2">
                    {{ $t('resvgu_table1_desc1') }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-borderless">
            <tbody>
              <tr style="border-top: 2px solid">
                <td style="border-bottom: 1px solid #acacac; background-color: #f5f5f5" align="center">
                  {{ $t('resvgu_table1_td2') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td3')" align="center"></td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; background-color: #f5f5f5; vertical-align: middle"
                  align="center"
                  width="50%"
                >
                  {{ $t('resvgu_table1_td4') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td5')" align="center"></td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; background-color: #f5f5f5; vertical-align: middle"
                  align="center"
                  width="50%"
                >
                  {{ $t('resvgu_table1_td6') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td7')" align="center"></td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; background-color: #f5f5f5; vertical-align: middle"
                  align="center"
                  width="50%"
                >
                  {{ $t('resvgu_table1_td8') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td9')" align="center"></td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; background-color: #f5f5f5; vertical-align: middle"
                  align="center"
                  width="50%"
                >
                  {{ $t('resvgu_table1_td10') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table1_td11')" align="center"></td>
              </tr>
              <tr>
                <td style="padding-bottom: 0" colspan="3">
                  <div class="text_align2">
                    {{ $t('resvgu_table1_desc1') }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="web table table-borderless border table-striped rounded">
            <tbody>
              <tr class="text-center">
                <td>
                  <b-icon icon="envelope" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon>
                </td>
                <td class="align-middle text-left">{{ $injectEmails($t('resvgu_email')) }}</td>
                <td>
                  <b-icon icon="calendar2-check" font-scale="3" style="padding: 5px 5px 5px 5px"></b-icon>
                </td>
                <td class="align-middle text-left">{{ $t('resvgu_time1') }}</td>
                <td class="align-middle text-left">{{ $t('resvgu_time2') }}</td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-borderless border table-striped rounded">
            <tbody>
              <tr class="text-center">
                <td>
                  <b-icon icon="envelope" font-scale="3" style="padding: 5px"></b-icon>
                </td>
                <td>
                  <div class="text-left">{{ $injectEmails($t('resvgu_email')) }}</div>
                </td>
              </tr>
              <tr class="text-center">
                <td>
                  <b-icon icon="calendar2-check" font-scale="3" style="padding: 5px"></b-icon>
                </td>
                <td>
                  <div class="text-left">{{ $t('resvgu_time1') }}</div>
                  <div class="text-left">{{ $t('resvgu_time2') }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <div style="margin-top: 50px; margin-bottom: 15px">
            <b-icon icon="exclamation-circle-fill" font-scale="1"></b-icon>
            <strong>{{ $t('resvgu_table2_title') }}</strong>
          </div>

          <ul class="rev_info list-unstyled">
            <table class="table table-borderless">
              <tbody>
                <tr style="border-top: 2px solid">
                  <td style="letter-spacing: -0.04rem">
                    <li>
                      {{ $t('resvgu_table2_desc1') }}
                    </li>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #acacac; border-top: 1px solid #acacac">
                  <td style="letter-spacing: -0.04rem">
                    <li>{{ $t('resvgu_table2_desc2') }}</li>
                  </td>
                </tr>
              </tbody>
            </table>
          </ul>

          <div style="margin-top: 50px; margin-bottom: 15px">
            <b-icon icon="exclamation-circle-fill" font-scale="1"></b-icon>
            <strong>{{ $t('resvgu_table3_title') }}</strong>
          </div>

          <table class="web table table-borderless">
            <tbody>
              <tr style="border-top: 2px solid">
                <td class="rb_border" style="vertical-align: middle; text-align: center; background-color: #f5f5f5">
                  {{ $t('resvgu_table3_desc1') }}
                </td>
                <td class="rb_border" style="vertical-align: middle; text-align: center; background-color: #f5f5f5">
                  {{ $t('resvgu_table3_desc3') }}
                </td>
                <td class="rb_border" style="vertical-align: middle; text-align: center; background-color: #f5f5f5">
                  {{ $t('resvgu_table3_desc5') }}
                </td>
                <td class="rb_border" style="vertical-align: middle; text-align: center; background-color: #f5f5f5">
                  {{ $t('resvgu_table3_desc7') }}
                </td>
              </tr>
              <tr>
                <td class="rb_border" style="vertical-align: middle; text-align: center">
                  {{ $t('resvgu_table3_desc2') }}
                </td>
                <td class="rb_border" style="vertical-align: middle; text-align: center">
                  {{ $t('resvgu_table3_desc4') }}
                </td>
                <td class="rb_border" style="vertical-align: middle; text-align: center">
                  {{ $t('resvgu_table3_desc6') }}
                </td>
                <td class="rb_border" style="vertical-align: middle; text-align: center">
                  {{ $t('resvgu_table3_desc8') }}
                </td>
              </tr>

              <tr>
                <td style="padding-bottom: 0" colspan="4">
                  <div class="text_align2">
                    {{ $t('resvgu_table3_desc9') }}
                  </div>
                </td>
              </tr>
              <tr>
                <td style="padding-bottom: 0" colspan="4">
                  <div class="text_align2">
                    {{ $t('resvgu_table3_desc10') }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <table class="mobile table table-borderless">
            <tbody>
              <tr style="border-top: 2px solid">
                <td style="border-bottom: 1px solid #acacac; background-color: #f5f5f5" align="center">
                  {{ $t('resvgu_table3_desc1') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table3_desc2')" align="center"></td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; background-color: #f5f5f5; vertical-align: middle"
                  align="center"
                >
                  {{ $t('resvgu_table3_desc3') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table3_desc4')" align="center"></td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; background-color: #f5f5f5; vertical-align: middle"
                  align="center"
                >
                  {{ $t('resvgu_table3_desc5') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table3_desc6')" align="center"></td>
              </tr>
              <tr>
                <td
                  style="border-bottom: 1px solid #acacac; background-color: #f5f5f5; vertical-align: middle"
                  align="center"
                >
                  {{ $t('resvgu_table3_desc7') }}
                </td>
              </tr>
              <tr>
                <td style="border-bottom: 1px solid #acacac" v-html="$t('resvgu_table3_desc8')" align="center"></td>
              </tr>

              <tr>
                <td style="padding-bottom: 0" colspan="3">
                  <div class="text_align2">
                    {{ $t('resvgu_table3_desc9') }}
                  </div>
                </td>
              </tr>
              <tr>
                <td style="padding-top: 0; padding-bottom: 0" colspan="3">
                  <div class="text_align2">{{ $t('resvgu_table3_desc10') }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'ReservguidancePage',
  data() {
    return {
      reserveguidance_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'OPERATION GUIDE',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.reserveguidance_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'ABOUT',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
.operationguide_body_hedaer {
  margin-top: 40px;
  margin-bottom: 50px;
}
.jpword {
  word-break: break-all;
}
.anotherword {
  word-break: keep-all;
}
.text_align1 {
  margin-left: 0.9rem;
  text-indent: -0.45rem;
}
.text_align2 {
  margin-left: 1rem;
  text-indent: -1rem;
}
ul.rev_info li:before {
  content: 'ㆍ';
  display: inline-block;
  vertical-align: middle;
}
.rb_border {
  border-bottom: 1px solid #acacac;
  border-right: 1px solid #acacac;
}
.info-ex-table {
  word-break: keep-all;
}
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.contentDesc {
  text-align: center;

  .title1 {
    margin-top: 3rem;
    margin-bottom: 5rem;
  }

  .title2 {
    margin-top: 3rem;
  }

  .title3 {
    margin-top: 1rem;
    margin-bottom: 5rem;
  }
}
@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Golf/operationguide_headerimage.png');
  }

  .web {
  }

  .mobile {
    display: none;
  }

  td {
    vertical-align: middle;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }

  .web {
    display: none;
  }

  .mobile {
  }

  li,
  td {
    font-size: 0.9rem !important;
    vertical-align: middle;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "예약안내",
    "resvgu_title": "예약 안내"
  },
  "en": {
    "breadcrumb": "Reservation Guide",
    "resvgu_title": "Reservation Guide",
    "resvgu_desc1": "PINX Golf Club operates upon the principle of one-on-one interactive service with our clients. We use telephone and e-mail for reservation instead of online reservation.",
    "resvgu_desc2": "We apply the following rules to establish wholesome golf reservation culture and provide equal opportunity for reservation among members. Please cooperate.",
    "resvgu_table1_title": " Golf Reservation Policy for Non-Members",
    "resvgu_table1_td2": "Operation",
    "resvgu_table1_td3": "Our golf club operates on a membership basis.",
    "resvgu_table1_td4": "Availability",
    "resvgu_table1_td5": "Non-members are not permitted to reserve 18 holes; only the designated 9-hole option for non-members is available.",
    "resvgu_table1_td6": "Reservation Period",
    "resvgu_table1_td7": "Reservations open from 9:00 a.m. on the Monday, 8 weeks prior to the date of play.",
    "resvgu_table1_td8": "Reservation Method",
    "resvgu_table1_td9": "Accepted by e-mail only.",
    "resvgu_table1_td10": "Restrictions",
    "resvgu_table1_td11": "Reservations for weekends and public holidays may be limited depending on course operation and seasonal conditions.",
    "resvgu_table1_desc1": "※ Temporary Closing : If necessary for operation such as natural disaster and course management.",
    "resvgu_tel": "TEL : +82-64-792-8000",
    "resvgu_email": "[[EMAIL:bookingKr]]",
    "resvgu_time1": "Open year round 09:00 ~ 17:30",
    "resvgu_time2": "Lunch Time 12:00 ~ 13:00",
    "resvgu_table2_title": " Guide on cancellation/change of reservation",
    "resvgu_table2_desc1": "Please contact us by 17:00, 7 days before the scheduled date of use for cancellation/change of reservation.",
    "resvgu_table2_desc2": "In case of inclement weather on the day of your round, if you wish to cancel, please contact the golf course front desk at 064-793-5000.",
    "resvgu_table3_title": " Rate",
    "resvgu_table3_desc1": "Category",
    "resvgu_table3_desc2": "Non-members",
    "resvgu_table3_desc3": "Monday ~ Part1 on Friday",
    "resvgu_table3_desc4": "KRW 129,440",
    "resvgu_table3_desc5": "Part2 on Friday ~ Part1 on Sunday, Public Holiday",
    "resvgu_table3_desc6": "KRW 169,440",
    "resvgu_table3_desc7": "Part2 on Sunday",
    "resvgu_table3_desc8": "KRW 149,440",
    "resvgu_table3_desc9": "※ Public charges and taxes KRW 21,120 (individual consumption tax, education tax, special tax for rural development, value added tax) excluded.",
    "resvgu_table3_desc10": "※ Only round with cart and caddie is allowed. (Self-round not available)"
  },
  "ja": {
    "breadcrumb": "予約のご案内",
    "resvgu_title": "予約のご案内",
    "resvgu_desc1": "ピンクスゴルフクラブはお客様の1：1対話型のサービスを原則としており、オンライン予約の代わりに電話とe-メールの受付を行っております。",
    "resvgu_desc2": "円滑なゴルフ予約文化の定着と会員様に均等な予約の機会を配分するために、 次のような違約規定を設けておりますのでご協力のほどお願い申し上げます。",
    "resvgu_table1_td1": "会員",
    "resvgu_table1_td2": "週末および休日",
    "resvgu_table1_td2_m": "会員 - 週末および休日",
    "resvgu_table1_td3": "3か月前～3週間前まで受け付けが可能で、ご予約の結果は2ヶ月前から順次お知らせします。<br/>（ただし、3週間前以降の受付は残余時間を割り振りすることを原則とし、予約の結果は翌日午後5時までにご連絡いたします。）",
    "resvgu_table1_td4": "平日",
    "resvgu_table1_td4_m": "会員 - 平日",
    "resvgu_table1_td5": "3か月前～7日前まで受付し、予約の結果は2ヶ月前から順次お知らせします。",
    "resvgu_table1_desc1": "※ コースの管理および季節の関係上、2部制で営業している場合、 9ホールのプレー後にプレーが一部遅延することがありますのでご了承ください。",
    "resvgu_table1_desc2": "※ 定期休場日‐毎月隔週でコースごとに休場",
    "resvgu_table1_desc3": "※ 臨時休場‐天候・災害およびコースの管理など運営上必要な場合は臨時休場",
    "resvgu_tel": "お問い合せ : +82-64-792-8000",
    "resvgu_email": "[[EMAIL:bookingKr]]",
    "resvgu_time1": "年中無休 09:00 ~ 17:30",
    "resvgu_time2": "昼食時間 12:00 ~ 13:00",
    "resvgu_table2_title": " キャンセル/および違約規定のご案内",
    "resvgu_table2_desc1": "※ ご予約の変更やキャンセルはご利用予定日の7日前の17時までにご連絡ください。",
    "resvgu_table2_desc2": "NO-SHOWおよび当日キャンセル：2か月停止",
    "resvgu_table2_desc3": "6日～1日前のキャンセル：1か月停止",
    "resvgu_table2_desc4": "非会員の6日前までのキャンセルおよびNo-Show : 非会員2人グリーンフィー賦課と予約制限",
    "resvgu_table2_desc5": "週末および休日の本人未来場（非会員のみ来場）：2か月停止",
    "resvgu_table2_desc6": "進行に非協力的な場合やスタート時間を無視した場合：累積2回発生時には1か月停止、",
    "resvgu_table2_desc7": "その他クラブの品位を毀損する行為（不健全な言語や態度）：累積2回発生時、1か月停止"
  }
}
</i18n>
